<template>
  <div
    :class="[
      'chat-history',
      {
        'full-screen': fullMode,
        'half-height': fullMode && halfMode,
        'full-height': fullMode && !halfMode,
      },
    ]"
    :style="isEmpty(historyDateChunks) ? 'align-items: center;' : ''"
  >
    <p class="empty-tips" v-if="isEmpty(historyDateChunks)">暂无历史对话</p>
    <div v-else class="flex-1" :class="{'flex-1-phone': ifMiniLayout}">
      <div v-for="(chunk, key) in validHistoryDateChunks" :key="key">
        <p
          v-if="fullMode && chunk.length !== 0"
          class="time"
          :style="key !== 'today' ? 'margin-top: 10px;' : ''"
        >
          {{ timeLabels[key] }}
        </p>
        <ul>
          <li
            v-for="(item, index) in chunk"
            :key="item.id || `${index}-${key}`"
            :class="{'item-content': true,'item-content--active': targetChatId === item.chat_id}"
            @click="submitQuestion(item)"
          >
            <span class="question-desc" :title="item.question">{{
              item.question
            }}</span>
            <span v-show="!fullMode" class="date-desc">{{
              calcDate(item)
            }}</span>
          </li>
        </ul>
      </div>
      <!-- 继续加载按钮 -->
      <div class="load-more" v-if="hasMore">
        <button class="load-more-btn" @click="getHistory(true)">加载更多</button>
      </div>
    </div>
    <div class="history-footer" v-if="fullMode">
      <el-button class="create-new-chat" type="primary" @click="createNewChat"
        >开启新对话
        <img src="@/assets/imgs/send-msg-icon.png" />
      </el-button>
    </div>
  </div>
</template>

<script>
import { API } from "./api";
import moment from "moment";
import "moment/locale/zh-cn";

moment.locale("zh-cn");

export default {
  props: {
    fullMode: {
      type: Boolean,
      default: false,
    },
    halfMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      historyDateChunks: null,
      timeLabels: {
        today: "今天",
        week: "本周内",
        month: "本月内",
        moreEarly: "更早",
      },
      taskList: [],  // 记录原始列表
      hasMore: false, // 是否有更多历史记录
      lastMessageId: '', // 最后一条消息的id，用于加载更多
    };
  },
  computed: {
    ifMiniLayout() {
      return this.$store.state.layout === "minimized";
    },
    targetChatId() {
      return this.$store.state.conversationId;
    },
    validHistoryDateChunks() {
      const result = {};
      for (const key of ["today", "week", "month", "moreEarly"]) {
        if (Array.isArray(this.historyDateChunks[key])) {
          result[key] = this.historyDateChunks[key];
        }
      }
      return result;
    },
  },
  watch: {},
  created() {
    this.getHistory();
  },
  methods: {
    /**
     * 获取历史记录
     * @param Boolean 是否追加
     */
    getHistory(ifAdd) {
      // console.log('get history');
      const url = "/v1/conversations";
      const lastId = ifAdd?this.lastMessageId:null
      const params = {
        user: this.$store.state.userId,
        limit: 20,
        last_id: lastId,
      };
      API
        .get(url, {params})
        .then((res) => {
          // 历史记录
          // console.log(res)
          if (res.status == 200) {
            if (ifAdd) {
              this.taskList.push(...res.data.data);
            }else {
              this.taskList = res.data.data;
            }
            this.hasMore = res.data.has_more;
            // console.log(this.taskList)
            this.historyDateChunks = this.handleHistoryData(this.taskList);
          } else {
            this.$message.error("获取历史记录失败");
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // 处理历史会话数据
    handleHistoryData(list) {
      if (list.length < 1) {
        return
      }
      // 单独处理data.has_more
      this.lastMessageId = list[list.length - 1].id;
      const arr = list;
      if (!arr && arr.length === 0) return {};
      const dateChunks = {
        today: [],
        week: [],
        month: [],
        moreEarly: [],
      };

      arr.forEach((item) => {
        const newObj = {
          chat_id: item.id,
          create_time: item.created_at,
          update_time: item.updated_at,
          question: item.name,
        };

        const now = moment();
        const questionTime = moment(newObj.update_time * 1000);
        const diffDays = now.diff(questionTime, "days");

        if (diffDays < 1) {
          dateChunks.today.push(newObj);
        } else if (diffDays < 7) {
          dateChunks.week.push(newObj);
        } else if (diffDays < 30) {
          dateChunks.month.push(newObj);
        } else {
          dateChunks.moreEarly.push(newObj);
        }
      });
      // 按时间降序排序
      for (const key in dateChunks) {
        dateChunks[key].sort((a, b) => {
          const aTime = moment(a.update_time);
          const bTime = moment(b.update_time);
          return aTime.isBefore(bTime)?1:-1;
        });
      }
      // console.log('dataChunks:', dateChunks);
      return dateChunks;
    },
    // 判断历史记录是否为空
    isEmpty(dateChunks) {
      if (!dateChunks) {
        return true;
      }
      let arr = [];
      arr = [
        ...dateChunks["today"],
        ...dateChunks["week"],
        ...dateChunks["month"],
        ...dateChunks["moreEarly"],
      ];
      if (arr.length === 0) {
        return true;
      } else {
        return false;
      }
    },
    // 计算时间距现在多久
    calcDate(item) {
      return moment(item.update_time * 1000).fromNow();
    },
    // 提交问题
    submitQuestion(item) {
      this.$store.commit('setConversationId',item.chat_id);
      this.debounce(this.$emit("submitQuestion"), 1000);
      this.getHistory(false);
    },
    // 新建会话
    createNewChat() {
      this.debounce(this.$emit("createNewChat"), 1000);
      this.getHistory(false);
    },
    // 防抖
    debounce(fn, delay) {
      let timer = null;
      return function () {
        let context = this;
        let args = arguments;
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          fn.apply(context, args);
        }, delay);
      };
    },
  },
};
</script>

<style scoped lang="less">
.chat-history {
  padding-bottom: 10px;
  box-shadow: 4px 4px 4px 0px #dfdfdfd9;
  width: 100%;
  // height: 100%;
  min-height: 20%;
  position: absolute;
  background-color: #fff;
  border-radius: 10px;
  z-index: 1;
  .empty-tips {
    text-align: center;
    padding-top: 10px;
    color: #b9b9b9;
    font-size: 16px;
    font-weight: 350;
  }
  ul {
    // max-height: 200px;
    // overflow-y: auto;
    // 隐藏滚动条
    /*
    &::-webkit-scrollbar {
      display: none;
    }
      */
  }
  // 存在刘海屏
  &.half-height {
    height: calc(100vh - 110px) !important;
  }
  // 全屏
  &.full-height {
    height: calc(100vh - 50px) !important;
  }
  // 全屏样式
  &.full-screen {
    flex: 1;
    position: static;
    background-color: #f8f8f8;
    border-radius: 0;
    box-shadow: none;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding-top: 21px;
    & > div {
      width: calc(100% - 8px);
    }
    .empty-tips {
      text-align: inherit;
      padding-top: 0 !important;
    }
    .time {
      color: #b9b9b9;
      margin-bottom: 10px;
      margin-left: 40px;
      font-size: 12px;
      font-family: Siyuanhei !important;
      font-weight: normal !important;
    }
    ul {
      // max-height: calc(100% - 90px);
      // width: 100%;
      // margin: 0 4px;
      .item-content {
        box-sizing: content-box;
        border-radius: 8px;
        font-size: 14px;
        padding: 12px 30px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .item-content--active {
        background-color: #fff;
        color: #fe2a20;
      }
    }
    .history-footer {
      width: 100%;
      height: 40px;
      bottom: 49px;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .create-new-chat {
        padding: 0;
        width: calc(100% - 28px);
        height: 38px;
        font-weight: 500 !important;
        font-size: 14px;
        background-color: #df0315;
        color: #fff;
        border-radius: 8px;
        border-color: #df0315;
        font-family: Siyuanhei !important;
        // font-weight: normal;
        &:hover {
          background-color: #c00000;
        }
        &:active {
          transform: scale(0.98);
        }
        img {
          width: 16px;
          height: 16px;
          margin-left: 15px;
        }
      }
    }
  }
}
.item-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  cursor: pointer;
  font-family: Siyuanhei !important;
  font-weight: normal !important;
  .question-desc {
    flex: 1;
    // 单行显示，超出部分显示省略号
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .date-desc {
    min-width: 50px;
    text-align: right;
  }
}
.item-content:hover {
  background-color: #f5f5f5;
  color: #fe2a20;
}
.flex-1 {
  flex: 1;
  overflow-y: auto;
}
.flex-1-phone {
  max-height: 60vh;
}
.load-more {
  margin-top: 8px;
  padding: 0 10px;
}
.load-more-btn {
  width: 100%;
  padding: 4px 0;
  border-radius: 10px;
  color: #df0315;
  border: 1px solid #df0315;
  transition: all 0.3s;
}
.load-more-btn:hover {
  background-color: #df0315;
  color: white;
}
</style>
